import {split, position, getLastCharIndex} from "../mathematics/parser";

export function getHighlightValue(view, value, activeMath, updateCells) {
	const cellsColor = {}; 
	let html = "";

	const escapeText = webix.template.escape;

	//value can be null
	if(value && value[0]=="="){
		const parts = split(value, view, null, activeMath);
		const sheet = view.getActiveSheet();

		let colorIndex = 1;

		for(let i = 0; i < parts.length; i++){
			if(i%2 === 0)
				html += escapeText(parts[i]);
			else{
				const crossheet = webix.isArray(parts[i]);
				const cellSheet = crossheet ? prepareSheet(parts[i][0], parts[i][2]) : "";

				const activeSheet = !crossheet && (!activeMath || activeMath == sheet);
				let cell = position((crossheet ? parts[i][1] : parts[i]).toUpperCase());
				const cellText = crossheet ? cellSheet+parts[i][1] : parts[i];

				const rangeName = crossheet && !getLastCharIndex(parts[i][1]);

				if(rangeName || activeSheet || (crossheet && parts[i][0] == sheet)){
					let repeatedColor;
					//range
					if((parts[i+1] == ":" && parts[i+2]) || rangeName){
						let nextCell, nextCellText;

						if(rangeName){
							const cells = parts[i][3].split(":");

							cell = position(cells[0]);
							nextCell = position(cells[1]);
						}
						else{
							nextCell = position((webix.isArray(parts[i+2]) ? parts[i+2][1] : parts[i+2]).toUpperCase());
							nextCellText = webix.isArray(parts[i+2]) ? cellSheet+parts[i+2][1] : parts[i+2];
							i+=2;
						}

						repeatedColor = setColor(view, cell[0], cell[1], nextCell[0], nextCell[1], colorIndex, cellsColor, updateCells);
						html += `<span class="webix_ssheet_highlight_color_${repeatedColor||colorIndex}">${rangeName ? cellText : cellText+":"+nextCellText}</span>`;
					}
					//OtherSheet!A1:A3 - do not highlight A3
					else if(parts[i-1] && parts[i-1][ parts[i-1].length-1 ] == ":"){
						html += cellText;
						continue;
					}
					//cell
					else{
						repeatedColor = setColor(view, cell[0], cell[1], cell[0], cell[1], colorIndex, cellsColor, updateCells);
						html += `<span class="webix_ssheet_highlight_color_${repeatedColor||colorIndex}">${cellText}</span>`;
					}

					const colors = 7;
					if(!repeatedColor)
						colorIndex += colorIndex == colors ? -1*(colors-1) : 1;
				}
				else
					html += cellText;
			}
		}
	}
	else
		html = escapeText(value);

	if(updateCells)
		view._highlightedCells = cellsColor;

	return html;
}

export function removeOldHighlight(view){
	if(view._highlightedCells)
		for(let area in view._highlightedCells){
			const cells = view._highlightedCells[area];
			changeCellCss(view, cells[0], cells[1], cells[2], true);
		}
	view._highlightedCells = {};
}

export function prepareSheet(sheet, escaped){
	if(!sheet)
		return "";
	const condition = webix.isUndefined(escaped) ? sheet.indexOf(" ") != -1 : escaped;
	return (condition ? `'${sheet}'` : sheet) + "!";
}

function prepareArea(first, second){
	return {
		start: Math.min(first, second),
		end: Math.max(first, second)
	};
}

function setColor(view, row1, col1, row2, col2, color, colors, updateCells){
	const row = prepareArea(row1, row2);
	const col = prepareArea(col1, col2);
	const index = [row.start, row.end, col.start, col.end].join(",");
	const coloredArea = colors[index];

	if(!coloredArea){
		colors[index] = [row, col, color];
		if(updateCells)
			changeCellCss(view, row, col, color);
	}
	else
		return coloredArea[2];
}

function changeCellCss(view, row, col, index, remove){
	const css = `webix_ssheet_highlight_background_${index}`;
	for (let r = row.start; r <= row.end; r++)
		for (let c = col.start; c <=  col.end; c++)
			view.$$("cells")[remove?"removeCellCss":"addCellCss"](r, c, css, true);
}